export default function ($http) {
    return function (model) {
        return $http.post('api/vmcaccount', model);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/addVmcAccount/addVmcAccount.js